module.exports = __webpack_public_path__ + "images/tick_mint.svg";